import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";
import ApiDocs from "@/pages/ApiDocs";
import Branding from "@/pages/Branding";
import Itineraries from "@/pages/Itineraries";
import ItineraryBuilder from "@/pages/ItineraryBuilder";
import SharedItinerary from "@/pages/SharedItinerary";
import AuthGoogleCallback from "@/pages/AuthGoogleCallback";
import TeamAccept from "@/pages/TeamAccept";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import CookiesPolicy from "@/pages/CookiesPolicy";
import RefundPolicy from "@/pages/RefundPolicy";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/google" element={<AuthGoogleCallback />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/developers" element={<ApiDocs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/team/accept" element={<TeamAccept />} />
      <Route path="/share/:shareId" element={<SharedItinerary />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/cookies-policy" element={<CookiesPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/branding" element={<ProtectedRoute><Branding /></ProtectedRoute>} />
      <Route path="/itineraries" element={<ProtectedRoute><Itineraries /></ProtectedRoute>} />
      <Route path="/itineraries/:id" element={<ProtectedRoute><ItineraryBuilder /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
